import { useState, useEffect } from "react";
import { debounce } from "../../delays/debounce.js";
const useMatchMedia = (mediaQuery) => {
  const queries = Array.isArray(mediaQuery) ? mediaQuery : [mediaQuery];
  const [matches, setMatches] = useState(() => queries.map((query) => window.matchMedia(query).matches));
  useEffect(() => {
    const mediaList = queries.map((query) => window.matchMedia(query));
    const updateMatches = () => {
      setMatches(mediaList.map((media) => media.matches));
    };
    updateMatches();
    const resizeHandler = debounce((_) => {
      updateMatches();
    }, 200);
    window.addEventListener("resize", resizeHandler);
    return () => window.removeEventListener("resize", resizeHandler);
  }, [mediaQuery]);
  return Array.isArray(mediaQuery) ? matches : matches[0];
};
export {
  useMatchMedia
};
